import { formatDate } from '@vestwell-frontend/helpers';

import { formatISO } from 'date-fns';

export const toLocalDate = (date?: string) => {
  // ISSUE WHEN PASSING ISO DATE AND NEGATIVE TIMEZONE to date-fns - format('1989-17-04', 'MM/dd/yyyy') -> '04-16-1989'
  return (date ? formatDate(date, 'MM/dd/yyyy') : date) as string | undefined;
};

export const toISODate = (date?: Date | string | number) =>
  (date ? formatISO(date, { representation: 'date' }) : date) as
    | string
    | undefined;
